import './InformationDutyOverlay.less';
import Markdown from 'nike-ui/src/components/markdown/Markdown';
import PopupNg from '@/ui/PopupNg';
import React from 'react';
import clsx from 'clsx';
import i18n from '@i18n';
import useLocalStorage from 'nike-ui/src/common/hooks/useLocalStorage';
import { DialogBody, DialogTitle } from '@/ui/dialogs/Dialog';
import { Docked } from '../dialogs/Dialog';
import { GOAL_OF_MONTH_PATHS } from 'nike-ui/src/components/goal-of-month/paths';
import { gomVoteAfterLogin } from 'nike-ui/src/components/goal-of-month/utils';
import { informationDutyLoaded$ } from '@/ui/subs';
import { showCookiebotDialog } from 'nike-ui/src/components/cookie';
import { useInterval } from 'nike-ui/src/common/hooks/useInterval';
import { useReframe } from 'nike-re-framejs';

function progressPercent(remaining) {
    if (remaining === 0) {
        return 0;
    }
    const max = 4;
    const current = remaining - 1;
    return 100 * ((max - current) / max);
}

function InformationDuty({ blocking }) {
    const { subscribe } = useReframe();
    const dataLoaded = subscribe(informationDutyLoaded$);
    const [elapsed, setElapsed] = useLocalStorage('information-duty-elapsed', 0);

    useInterval(
        () => {
            setElapsed(elapsed + 1);
            if (elapsed + 1 >= 5) {
                PopupNg.dispatcher.close();
                if (window.location.pathname.startsWith(GOAL_OF_MONTH_PATHS.GOAL_OF_MONTH.path)) {
                    gomVoteAfterLogin();
                }
            }
        },
        blocking && dataLoaded && elapsed < 5 ? 1000 : null
    );
    const remaining = 5 - elapsed;
    const width = progressPercent(remaining);

    return (
        <>
            <DialogTitle>
                <h2 className="icon">{i18n('information-duty.overlay.title')}</h2>
            </DialogTitle>
            <DialogBody className={clsx({ 'responsible-gaming-visible': !blocking })}>
                <Markdown>{window.INITIAL_DATA.informationDutyArticle}</Markdown>
                {blocking && (
                    <div className="sticky">
                        <div className="progress-wrap">
                            <span> {i18n('information-duty.overlay.countDownMessage', remaining)} </span>
                            <div className="progress">
                                <div
                                    className="progress-bar"
                                    style={{ width: width + '%', display: width < 0 ? 'none' : 'block' }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </DialogBody>
        </>
    );
}

function InformationDutyOverlay({ blocking }) {
    const onClose = () => {
        setTimeout(() => {
            PopupNg.dispatcher.close();
        }, 200);
        if (window.Cookiebot?.shouldReopen) {
            setTimeout(() => showCookiebotDialog(), 100);
            window.Cookiebot.shouldReopen = false;
        }
    };
    return (
        <Docked
            className={clsx('login-overlay information-duty-dialog', { blocking })}
            hideCloseButton={blocking}
            modal
            onClose={blocking ? null : onClose}
        >
            <InformationDuty blocking={blocking} />
        </Docked>
    );
}

export default InformationDutyOverlay;
